<div class="animated fadeIn rounded">
    <div class="card">
        <div class="card-header">
            <i class="fa fa-gift"></i> Giftcards
            <div class="card-header-actions btn-group" dropdown placement="bottom left">
                <!-- <button class="btn btn-sm btn-outline-success" type="button"><i class="fa fa-regular fa-floppy-disk"></i>&nbsp;Guardar Orden</button> -->
                <button class="btn btn-sm btn-outline-primary" type="button" (click)="addGiftCard()">
                    <i class="fa fa-plus"></i>&nbsp;Agregar GiftCard
                </button>

            </div>
        </div>
        <div class="card-body">
            <pos-table [data]="giftcards" [headers]="getHeaders()" [filters]="getFilters()"
                (dataChange)="getGiftCards($event)" [itemsPerPage]="20"></pos-table>
        </div>
    </div>
</div>